{
	"name": "colony",
	"roles": {
		"none": [0, 0, 0, 0],
		"outline": [0, 0, 0, 255],
		"white": [255, 255, 255, 255],
		"casing": [46, 54, 72, 255],
		"casing_lit": [72, 82, 106, 255],
		"casing_shadow": [30, 36, 50, 255],
		"casing_darkest": [16, 20, 30, 255],
		"rim": [94, 106, 134, 255],
		"bracket": [118, 130, 158, 255],
		"rivet": [132, 144, 172, 255],
		"recess": [24, 30, 44, 255],
		"trim": [0, 180, 210, 255],
		"trim_lit": [0, 210, 240, 255],
		"trim_dark": [0, 140, 170, 255],
		"brass": [210, 180, 70, 255],
		"hazard": [224, 190, 42, 255],
		"good": [104, 216, 124, 255],
		"good_dark": [60, 150, 40, 255],
		"warn": [240, 196, 72, 255],
		"bad": [232, 72, 72, 255],
		"amber": [230, 140, 30, 255],
		"amber_dark": [180, 90, 10, 255],
		"plasma": [40, 80, 220, 255],
		"plasma_lit": [140, 190, 255, 255],
		"core": [240, 245, 255, 255],
		"medical_dim": [150, 40, 40, 255],
		"medical": [210, 60, 55, 255],
		"medical_hot": [255, 120, 110, 255],
		"vial_red": [210, 70, 70, 255],
		"vial_teal": [60, 190, 175, 255],
		"vial_white": [220, 230, 235, 255],
		"vial_cap": [120, 110, 100, 255],
		"readout_off": [25, 55, 50, 255],
		"readout_on": [80, 220, 140, 255],
		"readout_hot": [180, 255, 200, 255],
		"wood": [65, 45, 30, 255],
		"wood_lit": [85, 60, 40, 255],
		"wood_dark": [45, 30, 20, 255],
		"roof": [55, 40, 28, 255],
		"roof_lit": [75, 55, 38, 255],
		"straw": [180, 155, 80, 255],
		"straw_dark": [140, 115, 55, 255],
		"liquid": [0, 190, 222, 255],
		"liquid_lit": [130, 228, 252, 255],
		"liquid_dark": [0, 150, 185, 255],
		"chamber": [18, 26, 38, 255],
		"chamber_lit": [34, 46, 64, 255],
		"glass": [120, 200, 220, 90],
		"ramp_orange": [240, 132, 56, 255],
		"ramp_lime": [176, 222, 88, 255],
		"ramp_bright": [150, 240, 160, 255]
	},
	"ramps": {
		"charge": ["bad", "ramp_orange", "warn", "ramp_lime", "good", "ramp_bright"],
		"heat": ["trim_dark", "trim", "warn", "ramp_orange", "bad"],
		"fill": ["trim_dark", "trim", "trim_lit"],
		"plasma": ["plasma", "plasma_lit", "core"],
		"glow": ["amber_dark", "amber", "hazard"]
	}
}
